import React from "react";

import { SidebarProvider } from "context/SidebarContext";

interface AppProviderProps {
  children: JSX.Element;
}

const AppProvider = ({ children }: AppProviderProps) => (
  <SidebarProvider>{children}</SidebarProvider>
);

export default AppProvider;
